export default "__VITE_ASSET__c428f9e5__"